import React from 'react';
import PropTypes from 'prop-types';
import ProfileIcon from 'components/ProfileIcon';
import { userShape } from 'utils/shapes';
import shouldUpdate from 'utils/shouldUpdate';
import './Ranking.css';

export const DISPLAY_DEFAULT = 'default';
export const DISPLAY_USER = 'user';
export const DISPLAY_SIMPLE = 'simple';
export const DISPLAY_FINAL = 'final';

const DEFAULT_WINNING_PLACES = [1];

function Ranking({
  rank,
  player,
  score,
  balance,
  places,
  display = DISPLAY_DEFAULT
}) {
  const winning =
    score > 0 && (places || DEFAULT_WINNING_PLACES).indexOf(rank) !== -1;
  if (display === DISPLAY_USER) {
    return getUserRanking(rank, winning, player, score, balance);
  } else {
    return getRanking(rank, winning, player, score, balance, display);
  }
}

function getUserRanking(rank, winning, player, score, balance) {
  const displayRank = rank !== undefined ? rank : '-';
  const displayScore = score !== undefined ? getNumberFormat(score) : 'N/A';
  const scoreLabel = score !== undefined ? ' pts' : '';
  return (
    <div
      className={`notranslate ranking ranking-user${
        winning ? ' winning-place' : ''
      }`}
    >
      <div className="profile">
        <ProfileIcon
          size={40}
          avatarData={player && player.avatarData}
          withBorder
        />
      </div>
      <div className="info">
        <div className="translate name">YOUR SCORE</div>
        <div className="values">
          <span className="points">
            <span>{displayScore}</span>
            <span>{scoreLabel}</span>
          </span>
        </div>
      </div>
      <div className="position">
        <div className={`position-bubble${winning ? ' filled' : ''}`}>
          {displayRank}
        </div>
      </div>
    </div>
  );
}

function getRanking(rank, winning, player, score, balance, display) {
  const displayName = (player && player.displayName) || 'Unknown';
  const displayRank = rank !== undefined ? rank : '';
  const scoreLabel = display !== DISPLAY_SIMPLE ? ' pts' : '';
  const displayScore = score !== undefined ? getNumberFormat(score) : '';
  const balanceLabel = balance !== undefined ? ' bal' : '';
  const displayBalance = balance !== undefined ? getNumberFormat(balance) : '';
  const displayClass = `notranslate ranking ranking-player ranking-${display}${
    winning ? ' winning-place' : ''
  }`;
  return (
    <div className={displayClass}>
      <div className="profile">
        <ProfileIcon
          size={40}
          avatarData={player && player.avatarData}
          withBorder
        />
      </div>
      <div className="name" title={displayName}>
        {displayName}
      </div>
      <div className="values">
        <span className="points">
          <span>{displayScore}</span>
          <span>{scoreLabel}</span>
        </span>
        {display === DISPLAY_DEFAULT && !!displayBalance && (
          <span className="balance">
            <span>{' ('}</span>
            <span>{displayBalance}</span>
            <span>{balanceLabel}</span>
            <span>{')'}</span>
          </span>
        )}
      </div>
      <div className="position">
        <div className={winning ? 'position-bubble filled' : ''}>
          {displayRank}
        </div>
      </div>
    </div>
  );
}

const numberFormatter = new Intl.NumberFormat();

function getNumberFormat(number) {
  return numberFormatter.format(number);
}

Ranking.propTypes = {
  rank: PropTypes.number,
  player: userShape,
  score: PropTypes.number,
  balance: PropTypes.number,
  places: PropTypes.arrayOf(PropTypes.number),
  display: PropTypes.string
};

function shouldComponentUpdate(props, nextProps) {
  return (
    props.rank !== nextProps.rank ||
    props.score !== nextProps.score ||
    props.balance !== nextProps.balance ||
    (props.player !== nextProps.player &&
      (!props.player ||
        !nextProps.player ||
        props.player.displayName !== nextProps.player.displayName))
  );
  // Note: display props are expected to be constant
}

export default shouldUpdate(shouldComponentUpdate)(Ranking);
